(function(window, undefined) {
    var $ = this.jQuery,
      ko = this.ko,
      console = this.console;